<template>
  <el-upload
    action=""
    :drag="drag"
    :multiple="multiple"
    :disabled="disabled"
    :limit="limit"
    :http-request="upload"
    :auto-upload="false"
  >
    <template #trigger>
      <i class="el-icon-upload" />
      <p class="p-0 m-0">
        <template v-if="drag">
          Drop files here or
        </template>
        <em>click to upload</em>
      </p>
    </template>
  </el-upload>
</template>

<script>
export default {
  props: {
    drag: {
      type: Boolean,
      required: false,
      default: false
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    limit: {
      type: Number,
      required: false,
      default: undefined
    }
  },
  methods: {
    async upload () {
      //
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .el-upload {
    width: 100%;

    > .el-upload-dragger {
      width: 100%;
    }
  }
</style>
